import styled, { css } from 'styled-components';

export const StyledCallMeBack = styled.div`
  position: fixed;
  width: auto;
  height: auto;
  bottom: 21px;
  right: 20px;
  z-index: 999;
  font-family: ${props => props.theme.font.regular};
  pointer-events: ${props => (props.isVisible ? 'all' : 'none')};

  @media (min-width: 1200px) {
    right: 20px;
  }

  @media (min-width: 1500px) {
    right: 180px;
  }

  ${props =>
    props.isVisible &&
    css`
      width: 100vw;
      height: 100%;
      bottom: 0;
      right: 0;
      z-index: 1000000;

      ${props => props.theme.mediaQueries.tablet} {
        width: auto;
        height: auto;
        bottom: 20px;
        right: 20px;

        @media (min-width: 1200px) {
          right: 20px;
        }

        @media (min-width: 1500px) {
          right: 180px;
        }
      }
    `}
`;

export const StyledCallMeBackFormWrapper = styled.div`
  display: block;
  position: relative;
  width: 100%;
  overflow: hidden;
  border-radius: 0;
  height: 100%;

  ${props => props.theme.mediaQueries.tablet} {
    border-radius: 10px;
    width: 320px;
    height: auto;
  }
`;

export const StyledCallMeBackForm = styled.form`
  position: relative;
  top: 0;
  left: 0;
  transform: translateY(${props => (props.isVisible ? 0 : 100)}%);
  transition: transform 0.25s linear 0s;
  background: ${props => props.theme.color.greenBlue};
  padding: 40px 30px 20px;
  height: 100%;

  ${props => props.theme.mediaQueries.tablet} {
    height: auto;
  }

  input {
    width: 100%;
    padding: 16px;
    padding-left: 0;
    font-size: 16px;
    border-radius: 0;
    margin-bottom: 20px;
    color: white;
    background-color: transparent;
    border: none;
    border-bottom: 1px solid white;
    outline: none;

    &::placeholder {
      color: white;
      opacity: 1;
    }
  }

  button {
    box-shadow: none;
    border: 1px solid white;
    line-height: 40px;
    margin-bottom: 24px;
  }
`;

export const StyledCallMeBackCloser = styled.div`
  position: absolute;
  width: 20px;
  height: 20px;
  top: 10px;
  right: 10px;
  opacity: ${props => (props.isVisible ? 1 : 0)};
  pointer-events: ${props => (props.isVisible ? 'all' : 'none')};
  cursor: pointer;
`
export const StyledCallMeBackText = styled.div`
  color: white;
  width: 100%;
  font-size: 14px;
  font-family: ${props => props.theme.font.regular};
`;

export const StyledCallMeBackFormResponse = styled.div`
  display: inline-block;
  background: ${props => props.theme.color.greenBlue};
  color: white;
  padding: 60px 20px;
  width: 100vw;
  height: 100vh;

  ${props => props.theme.mediaQueries.tablet} {
    width: auto;
    height: auto;
  }
`;

export const StyledCallMeBackErrors = styled.span`
  display: inline-block;
  color: white;
  font-size: 14px;
  margin-bottom: 20px;
`;
